module.exports = __webpack_public_path__ + "img/crown.c6b2aff.svg";